module.exports = "/images/vendor/flag-icon-css/flags/4x3/lv.svg?8b293d984cea7db72e62598083dc759d";